import { Nullable } from '@/utils/types';

export function stripNbsp (html?: Nullable<string>): string {
  if (!html) return '';
  return html.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
}
